import React, { useEffect, useMemo, useState } from "react";
import useStyles from 'isomorphic-style-loader/useStyles'
import classes from './style.module.scss'
import NormalPage from "../../../../layout/normal-page";
import { FormattedMessage, useIntl } from "react-intl";
import { CartCountIcon } from "../../components/cart-count-icon";
import { useSensors } from "../../../../../../hooks/sensor";
import {FilterProductsNoSensors} from "../../fragments/filter-products";
import { action_add_gifts_list, action_fetch_gift_info, action_fetch_gifts_list, action_init_cart } from "../../../../../../../store/actions/pages/cart";
import { action_fetch_cart_count } from "../../../../../../../store/actions/global";
import { useDispatch, useSelector, useStore } from "react-redux";
import { useHistory, useParams } from "react-router-dom";
import { useQuery } from "../../../../../../hooks/common";

const GiftPromptMsg = props => {
    useStyles(classes)
	const {giftInfo, intl, history} = props
    const [giftLabel, setGiftLabel] = useState('')

    useEffect(() => {
		if(giftInfo?.warnMsg || giftInfo?.giftWarnMsg){
			const {warnMsg, giftWarnMsg} = giftInfo
			setGiftLabel(warnMsg || giftWarnMsg)
		}
	}, [giftInfo?.warnMsg, giftInfo?.giftWarnMsg])

    return (
        <div className={classes.FreeGiftPickBox}>
			<div className={classes.PickLine}>
				<span className={classes.PickLabel} dangerouslySetInnerHTML={{__html:giftLabel}}></span>
                {
					!giftInfo?.canBuyGift ?
					<span className={classes.PickIcon}
						  onClick={() => {
							history.go(-1)
						  }}>
						<span>{intl.formatMessage({id: 'add'})} {'>'}</span>
					</span>:
					<React.Fragment></React.Fragment>
				}
			</div>
        </div>
    )
}


const FreeGifts = props => {
    useStyles(classes)
    const pageCart = useSelector(state => state.pageCart)
	const global = useSelector(state => state.global)
    const dispatch = useDispatch()
    const store = useStore()
    const params = useParams()
    const query = useQuery()
    const history = useHistory()
    const Intl = useIntl()
    const {
        cart,
        giftInfo,
        giftProducts,
        giftLoading,
        giftFinished,
        cartCount,
		filerPromptMsg,
    } = pageCart || {}
    // const {giftRegionalCase} = cart || {}
    const giftRegionalCase = cart?.giftRegionalCase || giftInfo
    const giftCollectionId = useMemo(() => {
        if(giftRegionalCase?.deepLink?.params?.[2]){
            let id = giftRegionalCase?.deepLink?.params?.[2]?.split("giftCollectionId=")?.[1]
            if(id?.indexOf("&") != -1){
                id = id?.split("&")[0]
            }
            return id
        } else {
            return null
        }
    }, [giftRegionalCase?.deepLink?.params])

	const {countCart} = global || {}
    const [sensors, setSensors] = useState(useSensors())

    const difference = filerPromptMsg?.difference?.amount || 0

    useEffect(async () => {
        window.scrollTo({
            top: 0,
        })
        if (window.__INITIAL_STATE__) {
			// Allow the passed state to be garbage-collected
			delete window.__INITIAL_STATE__
		} else {
            if(!cart && !giftInfo){
                await FreeGifts.fetchData(store, params, query, {})
            }
		}
        // if(!giftProducts || giftProducts?.length < 1 && giftCollectionId){
        //     await dispatch(action_fetch_gifts_list(giftCollectionId))
        // }
		if(!cartCount && !countCart){
			updateCartCount()
		}
    }, [])

    useEffect(async () => {
        if((!giftProducts || giftProducts?.length < 1) && giftCollectionId){
            await dispatch(action_fetch_gifts_list(giftCollectionId))
        }
    }, [giftCollectionId])

    const onScroll = async () => {
        if(!giftCollectionId)return
        await dispatch(action_add_gifts_list(giftCollectionId))
    }

    const updateCartCount = () => {
        dispatch(action_fetch_cart_count())
    }

    const cartCountNum = useMemo(() => {
		// console.log("cartCount: ", cartCount, "countCart: ", countCart)
		if(!cartCount && !countCart){
			return 0
		} else {
			return countCart
		}
	}, [cartCount, countCart])

    return (
        <div className={classes.FreeGifts}>
            <NormalPage
                onBack={() => { history.goBack() }}
                title={<FormattedMessage id="free_gift" defaultMessage="Free gifts" />}
                extra={<CartCountIcon cartCount={cartCountNum}/>}
                hideSecure={true}
                >
                <GiftPromptMsg
                    giftInfo={giftRegionalCase}
                    difference={difference}
                    intl={Intl}
                    history={history}
                    />

                <FilterProductsNoSensors
                    sensors={sensors}
                    products={giftProducts}
                    request={onScroll}
                    loading={giftLoading}
                    finished={giftFinished}
                    giftInfo={giftRegionalCase}
                    />
            </NormalPage>
        </div>
    )
}

FreeGifts.fetchData = async (store, params, search, headers) => {
    // await store.dispatch(action_init_cart(headers))
    await store.dispatch(action_fetch_gift_info(headers))
}

export default FreeGifts